import { render, staticRenderFns } from "./faq-edit.vue?vue&type=template&id=43bc33df"
import script from "./faq-edit.vue?vue&type=script&lang=js"
export * from "./faq-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports